import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchCriteriaStateSelector } from '../store/searchCriteria/searchCriteriaSelectors';
import fetchSearchCriteriaThunk from '../store/searchCriteria/actions/fetchSearchCriteria';
/**
 * A custom hook that returns an group of "searchCriteria" state-related actions wrapped
 * into a single object.
 */
export var useSearchCriteriaActionsDispatches = function () {
    var dispatch = useDispatch();
    var fetchSearchCriteria = useCallback(function () { return dispatch(fetchSearchCriteriaThunk()); }, [dispatch]);
    return { fetchSearchCriteria: fetchSearchCriteria };
};
/**
 * A custom hook that, by default, returns the relevant information of the "searchCriteria" state
 * using the `searchCriteriaStateSelector` and its related actions.
 * It is possible to override the selection by providing a custom selector.
 */
// eslint-disable-next-line max-len
export var useSearchCriteria = function (selector) {
    if (selector === void 0) { selector = searchCriteriaStateSelector; }
    var state = useSelector(selector);
    var actions = useSearchCriteriaActionsDispatches();
    return [state, actions];
};
